// Activity Connection - Calendar Builder
// Author: Allen Peloquin (PNDLM)
//
// actions.js - Redux actions for app state transitions
//
import $ from 'jquery'
import axios from 'axios'

import { fetchJson } from '../lib/ACHelpers'
import UserOutPSP from '../model/UserOutPSP';
import OfflineSaveService from "../services/OfflineSaveService";
import {detectIEBrowser2, createToken, getNewTokenFromServer} from "./DocumentListActions";
import * as Constant from '../data/constant'
import ThumbnailGenerationService from '../services/ThumbnailGenerationService';

// Redux Built-in Actions
export const REDUX_INIT = "@@redux/INIT"

// UI Actions
export const SELECT_ELEMENT = "SELECT_ELEMENT"		// when opening an editor
export const CANCEL_ELEMENT = "CANCEL_ELEMENT"		// closing an editor without persist
export const UI_DRAG_START = "UI_DRAG_START"		// dragging a box
export const UI_DRAG_END = "UI_DRAG_END"			// dragging a box
export const UI_RESIZE_START = "UI_RESIZE_START"	// resizing a box handle
export const UI_RESIZE_END = "UI_RESIZE_END"		// resizing a box handle
export const UI_COMPLETE_DRAG_RESIZE = "UI_COMPLETE_DRAG_RESIZE" // when we are complete and want to reset to nominal
export const EDITOR_NODE_SET_INFO = "EDITOR_NODE_SET_INFO"
export const EDITOR_NODE_CLEAR = "EDITOR_NODE_CLEAR"

export const RESET_PAGE = "RESET_PAGE"				// when opening an editor (set page to 1)
export const INCREMENT_PAGE = "INCREMENT_PAGE"		// next page clicked
export const DECREMENT_PAGE = "DECREMENT_PAGE"		// previous page clicked
export const SET_PAGE_ZOOM = "SET_PAGE_ZOOM"		// zoom changed

// UI State
export const UPDATE_DOCUMENT = "UPDATE_DOCUMENT"	// if a user tweaks unpersisted state during the creation process
export const UPDATE_PREV_DOCUMENT = "UPDATE_PREV_DOCUMENT"
export const DUPLICATE_DOCUMENT = "DUPLICATE_DOCUMENT" // empties out some keys and sets the current owner
export const MODIFY_TEMPLATE = "MODIFY_TEMPLATE" // empties out some keys and sets the current owner
export const DESIGN_DOCUMENT = "DESIGN_DOCUMENT"	// user selects a public design during non-advanced creation, fill it in
export const UPDATE_EDITOR = "UPDATE_EDITOR"		// user made a state change such as 'auto-fits text' that needs a state update within the editor
export const UPDATE_CREATE = "UPDATE_CREATE"		// user made a state change for the create dialogs
export const SET_EDITOR_MODE = "SET_EDITOR_MODE"	// if the editor needs to style for export, advanced modes
export const SET_NEWSLETTER_BOX_EDITOR_MODE = "SET_NEWSLETTER_BOX_EDITOR_MODE"  // if editor will create content boxes on drag
export const SET_EDITOR_TEMPLATING = "SET_EDITOR_TEMPLATING" // if true, do not render page margin
export const SET_DOCUMENT_TYPE = "SET_DOCUMENT_TYPE" // certain rules apply to one but not the other
export const REQUEST_DELETE_DOCUMENT = "REQUEST_DELETE_DOCUMENT"
export const DELETED_DOCUMENT = "DELETED_DOCUMENT"

export const CREATE_NEXT = "CREATE_NEXT"			// forward one step in the create wizard
export const CREATE_PREVIOUS = "CREATE_PREVIOUS"	// back one step in the create wizard
export const CREATE_SET = "CREATE_SET" 				// set the step in the create wizard (TODO: Merge prev next into this)

export const ELEMENT_CLEAR_IMAGE = "ELEMENT_CLEAR_IMAGE" // clear background image from edited element
export const DOCUMENT_SET_BACKGROUNDS = "DOCUMENT_SET_BACKGROUNDS" // set background ids

export const IMAGE_LIBRARY_UPLOADED = "IMAGE_LIBRARY_UPLOADED" 	// when file upload completes
export const IMAGE_LIBRARY_SELECTED = "IMAGE_LIBRARY_SELECTED" 	// when an image is selected in the list for manipulation
export const IMAGE_LIBRARY_TAB = "IMAGE_LIBRARY_TAB" 			// switching tabs
export const IMAGE_LIBRARY_INSERT = "IMAGE_LIBRARY_INSERT" 		// upon confirmation of selection
export const IMAGE_LIBRARY_RELOAD = "IMAGE_LIBRARY_RELOAD"

export const ELEMENT_EDIT_ATTRIBUTE = "ELEMENT_EDIT_ATTRIBUTE" 	// upon selecting an attribute picker in advanced mode
export const ELEMENT_SET_ATTRIBUTE = "ELEMENT_SET_ATTRIBUTE" 	// upon selecting a value for an attribute picker, so it changes and closes
export const ELEMENT_EDIT_AND_SET_ATTRIBUTE = "ELEMENT_EDIT_AND_SET_ATTRIBUTE" // unify the steps for certain non-swatch cases like editor changes
export const ELEMENT_PREVIEW_CHANGED = "ELEMENT_PREVIEW_CHANGED" // upon editor changes

export const ORDER_BEGIN = "ORDER_BEGIN"
export const ORDER_DOCUMENT = "ORDER_DOCUMENT"
export const ORDER_COMPLETE = "ORDER_COMPLETE"
export const ORDER_ERROR = "ORDER_ERROR"
export const ORDER_CANCEL = "ORDER_CANCEL"

// UI State Hints
export const UI_LOADING = "UI_LOADING"				// show the fetch spinner
export const UI_SAVING = "UI_SAVING"				// show save spinner
export const UI_CREATE_VISIBLE = "UI_CREATE_VISIBLE"// set creation modal visibility
export const UI_IMAGE_LIBRARY_VISIBLE = "UI_IMAGE_LIBRARY_VISIBLE" 	// set image library modal visibility
export const UI_IMAGE_LIBRARY_LOADING = "UI_IMAGE_LIBRARY_LOADING" 	// set image library loading to avoid spamming requests
export const UI_ORDER_PLACED = "UI_ORDER_PLACED" 	// user order succeeded
export const UI_RESET_FLASH_MESSAGE = "UI_RESET_FLASH_MESSAGE" 		// reset UI message

// Network Actions
export const NETWORK_ACTIVITY_INDICATOR = "NETWORK_ACTIVITY_INDICATOR"
export const REQUEST_FETCH_DOCUMENT = "REQUEST_FETCH_DOCUMENT"
export const ERROR_FETCH_DOCUMENT = "ERROR_FETCH_DOCUMENT"
export const PERSIST_DOCUMENT = "PERSIST_DOCUMENT"	// save changes to a document to
export const RECEIVE_DOCUMENT = "RECEIVE_DOCUMENT"	// get a document {} to rebind, if it includes gridElements [], rebind that too
export const ERROR_DOCUMENT = "ERROR_DOCUMENT"		// server or transport error case

export const PERSIST_ELEMENT = "PERSIST_ELEMENT"	// save changes to an element, will get [] back of all elements
export const RECEIVE_ELEMENT = "RECEIVE_ELEMENT"	// got an elements to rebind, closes any open editor and flushes state
export const ERROR_ELEMENTS = "ERROR_ELEMENTS"		// server or transport error case, leaves any editor open to fix errors
export const REMOVE_ELEMENT = "REMOVE_ELEMENT"		// DELETE succeeded, prune local model matching id

export const RECEIVE_PAGE = "RECEIVE_PAGE"			// got a page to rebind, redraws document

export const RECEIVE_IMAGES_INDEX = "RECEIVE_IMAGES_INDEX"	// got images for the library component
export const ERROR_IMAGES_INDEX = "ERROR_IMAGES_INDEX" 		//
export const PERSIST_IMAGE = "PERSIST_IMAGE" 				// upload file for image library
export const PERSIST_BACKGROUND_IMAGE = "PERSIST_BACKGROUND_IMAGE" // upload file for admin background section of image library

export const REQUEST_ORDER_PRINTS = "REQUEST_ORDER_PRINTS"	// user triggers an order request

export const RECEIVE_PAPER_SIZES_INDEX = "RECEIVE_PAPER_SIZES_INDEX"	// got paper sizes
export const ERROR_PAPER_SIZES_INDEX = "ERROR_PAPER_SIZES_INDEX" 		//


export const SET_CREATE_TEMPLATING = "SET_CREATE_TEMPLATING"
// List Templates
export const REQUEST_DOCUMENT_TEMPLATES = "REQUEST_DOCUMENT_TEMPLATES"
export const REQUEST_PSP_PRODUCTS = "REQUEST_PSP_PRODUCTS"
export const RECEIVE_DOCUMENT_TEMPLATES = "RECEIVE_DOCUMENT_TEMPLATES"
export const ERROR_DOCUMENT_TEMPLATES = "ERROR_DOCUMENT_TEMPLATES"
export const SET_SELECTED_DOCUMENT_TEMPLATE = "SET_SELECTED_DOCUMENT_TEMPLATE"	//

// Filter Template
export const FILTER_TEMPLATE_YEAR = "FILTER_TEMPLATE_YEAR"
export const FILTER_TEMPLATE_MONTH = "FILTER_TEMPLATE_MONTH"
export const FILTER_TEMPLATE_SIZE = "FILTER_TEMPLATE_SIZE"
export const FILTER_TEMPLATE_LAYOUT = "FILTER_TEMPLATE_LAYOUT"

export const MULTI_SELECT_MODE = "MULTI_SELECT_MODE"

// Tooltips
export const REQUEST_TOOLTIPS = "REQUEST_TOOLTIPS"
export const RECEIVE_TOOLTIPS = "RECEIVE_TOOLTIPS"
export const ERROR_TOOLTIPS = "ERROR_TOOLTIPS"

// Revision
export const REQUEST_REVISIONS = "REQUEST_REVISIONS"
export const RECEIVE_REVISIONS = "RECEIVE_REVISIONS"
export const ERROR_REVISIONS = "ERROR_REVISIONS"
export const SHOW_REVISION_HISTORY = "SHOW_REVISION_HISTORY"

/* ACTION CREATORS FOR EDITOR */

/* UI User Interaction Actions */
export function selectElement(selectedElement) {
	// select an element with the content of this element id
	return { type: SELECT_ELEMENT, selectedElement }
}

export function cancelElement() {
	// made change to element text
	return { type: CANCEL_ELEMENT }
}

export function uiStartDrag(fromX, fromY) {
	return { type: UI_DRAG_START, fromX, fromY }
}

export function uiEndDrag(toX, toY) {
	return { type: UI_DRAG_END, toX, toY }
}

export function uiStartResize() {
	return { type: UI_RESIZE_START }
}

export function uiEndResize() {
	return { type: UI_RESIZE_END }
}

export function uiCompleteDragOrResize() {
	return { type: UI_COMPLETE_DRAG_RESIZE }
}

export function editorNodeSetInfo(nodeInfo) {
	return { type: EDITOR_NODE_SET_INFO, nodeInfo }
}

export function editorNodeClear() {
	return { type: EDITOR_NODE_CLEAR }
}

export function incrementPage() {
	return { type: INCREMENT_PAGE }
}

export function decrementPage() {
	return { type: DECREMENT_PAGE }
}

export function setPageZoom(newValue) {
	return { type: SET_PAGE_ZOOM, zoomValue: newValue }
}

/* UI Refresh Actions */
export function updateDocument(document) {
	// when doc-level settings change, we want to re-render the document
	return { type: UPDATE_DOCUMENT, document }
}

export function updatePrevDocument(doc) {
	return { type: UPDATE_PREV_DOCUMENT, doc }
}

export function duplicateDocument(doc) {
	return { type: DUPLICATE_DOCUMENT, doc }
}

export function modifyTemplate(doc) {
	return { type: MODIFY_TEMPLATE, doc }
}


export function designDocument(doc) {
	return { type: DESIGN_DOCUMENT, doc }
}

export function updateEditor() {
	// when editor-level settings change, we want to re-render the document
	return { type: UPDATE_EDITOR }
}

export function updateCreate() {
	// when editor-level settings change, we want to re-render the document
	return { type: UPDATE_CREATE }
}

export function setEditorMode(mode = 'normal') {
	return { type: SET_EDITOR_MODE, mode }
}

export function setNewsletterBoxEditorMode(newsletterState) {
	return { type: SET_NEWSLETTER_BOX_EDITOR_MODE, mode: newsletterState }
}

export function setTemplating(template = false) {
	return { type: SET_EDITOR_TEMPLATING, template }
}

export function setDocumentType(documentType = 'calendar') {
	return { type: SET_DOCUMENT_TYPE, documentType }
}

export function createNext(maxPage = undefined) {
	return { type: CREATE_NEXT, maxPage }
}

export function createPrevious(minPage = 1) {
	return { type: CREATE_PREVIOUS, minPage }
}

export function createSet(pageNumber) {
	return { type: CREATE_SET, pageNumber }
}

export function elementClearImage() {
	return { type: ELEMENT_CLEAR_IMAGE }
}

export function documentSetBackgrounds(imageId) {
	return { type: DOCUMENT_SET_BACKGROUNDS, imageId }
}

export function documentClearBackgrounds() {
	return documentSetBackgrounds(null)
}

export function imageLibraryUploadComplete(uploadResultJson) {
	if (uploadResultJson.result ) {
		return {type: IMAGE_LIBRARY_UPLOADED, image: uploadResultJson.result.image}
	}
	return null
}

export function imageLibraryReload() {
	return {type: IMAGE_LIBRARY_RELOAD}
}

export function imageLibrarySelected(image = undefined) {
	return { type: IMAGE_LIBRARY_SELECTED, image }
}

export function imageLibraryTab(tab = 'library') {
	return { type: IMAGE_LIBRARY_TAB, tab }
}

export function imageLibraryInsert() {
	return { type: IMAGE_LIBRARY_INSERT }
}

export function elementEditAttribute(attribute = undefined) {
	return { type: ELEMENT_EDIT_ATTRIBUTE, attribute }
}

export function elementClearAttribute() {
	return this.elementEditAttribute(undefined)
}

export function elementSetAttribute(value = undefined) {
		if(value !== undefined) {
			return { type: ELEMENT_SET_ATTRIBUTE, value }
		}
		return Promise.resolve()
}

export function elementEditAndSetAttribute(attribute = undefined, value = undefined) {
	return { type: ELEMENT_EDIT_AND_SET_ATTRIBUTE, attribute, value }
}

export function elementPreviewChanged(value = undefined) {
	return { type: ELEMENT_PREVIEW_CHANGED, value}
}

export function beginDocumentOrder(documentId = undefined) {
	return { type: ORDER_BEGIN, documentId: documentId }
}

export function closeDocumentOrder() {
	return { type: ORDER_CANCEL }
}

function requestTooltips() {
	return { type: REQUEST_TOOLTIPS }
}

function receiveTooltips(json) {
	return { type: RECEIVE_TOOLTIPS, json, receivedAt: Date.now() }
}

function receiveTooltipsError() {
	return { type: ERROR_TOOLTIPS }
}

function requestRevisions() {
	return { type: REQUEST_REVISIONS }
}

function receiveRevisions(json) {
	return { type: RECEIVE_REVISIONS, json, receivedAt: Date.now() }
}

function receiveRevisionsError() {
	return { type: ERROR_REVISIONS }
}

function requestDocumentTemplates() {
	return { type: REQUEST_DOCUMENT_TEMPLATES }
}

function requestPSPProducts() {
    return { type: REQUEST_PSP_PRODUCTS }
}

function receiveDocumentTemplates(json) {
	return { type: RECEIVE_DOCUMENT_TEMPLATES, json, receivedAt: Date.now() }
}
function receivePSPProduct(json) {
    return { type: REQUEST_PSP_PRODUCTS, json, receivedAt: Date.now() }
}


function requestDeleteDocument(documentId) {
	return { type: REQUEST_DELETE_DOCUMENT, documentId }
}

function deletedDocument(documentId) {
	return { type: DELETED_DOCUMENT, documentId }
}

/* UI State Transition Actions */
function uiFetching() {
	// UI trigger that we are loading
	return { type: UI_LOADING }
}

function uiSaving() {
	// UI trigger that we are persisting
	return { type: UI_SAVING }
}

export function uiCreateVisibility(value = false) {
	// TODO: Maybe scenario is passed in?
	// UI trigger that we are creating a new document based on the current scenario
	return { type: UI_CREATE_VISIBLE, value }
}

export function uiImageLibraryVisibility(value = false, goal = undefined) {
	return { type: UI_IMAGE_LIBRARY_VISIBLE, value, goal }
}

export function uiImageLibraryLoading(value = false) {
	return { type: UI_IMAGE_LIBRARY_LOADING, value }
}

export function networkIndicator(value = false) {
	return { type: NETWORK_ACTIVITY_INDICATOR, value }
}

export function uiOrderPlaced() {
	return { type: UI_ORDER_PLACED, message: "Your order has been placed successfully!" }
}

export function uiResetFlashMessage() {
	return { type: UI_RESET_FLASH_MESSAGE }
}

/* Network Activities */
export function persistDocument(document) {
	if (document.name != null) {
		document.name = document.name.trim();
	}

	return (dispatch, getState) => {
		dispatch(uiSaving())
		return fetchJson('/gridDocuments',
			'put',
			document.serialize()
		)
		.then(async json => {
			if (json.result.invalid) {
				if(getState().isDuplicating && getState().selectedDocumentTemplate) {
					dispatch(setSelectedDocumentTemplate(null));
				}
				alert(json.result.invalid);
			} else {
				const gridDocumentId = json.result.gridDocument.gridDocumentId;
				sessionStorage.setItem('documentEdited', JSON.stringify({
					gridDocumentId: gridDocumentId,
					isShowModal: 0
				}));
				await dispatch(receiveDocument(json.result.gridDocument));
				dispatch(updatePrevDocument(getState().doc));

				const state = getState();
				if (isEditingCalendar(state)) {
					OfflineSaveService.getInstance().setCurrentGridDocumentId(gridDocumentId);
				}

				ThumbnailGenerationService.getInstance().add(gridDocumentId, state.currentUser.userId);
			}
		})
		.catch((err) => {
			console.log("Error", err)
			alert("Save failed, please try again:", err)
		})
	}
}

export function modifyTemplateDocument(document) {
    if (document.name != null) {
        document.name = document.name.trim();
    }

    return (dispatch, getState) => {
        dispatch(uiSaving())
        return fetchJson(`/gridDocuments/${document.gridDocumentId}`,
            'put',
            document.serialize()
        )
            .then(json => {
                if (json.result.invalid) {
                    alert(json.result.invalid);
                } else {
                    sessionStorage.setItem('documentEdited', JSON.stringify({
                        gridDocumentId: json.result.gridDocument.gridDocumentId,
                        isShowModal: 0
                    }));
                    dispatch(receiveDocument(json.result.gridDocument))
                    ThumbnailGenerationService.getInstance().add(getState().doc.gridDocumentId, getState().currentUser.userId);
                }
            })
            .catch((err) => {
                console.log("Error", err)
                alert("Save failed, please try again:", err)
            })
    }
}

function requestFetchDocument() {
	return { type: REQUEST_FETCH_DOCUMENT }
}

function receiveFetchDocumentError() {
	return { type: ERROR_FETCH_DOCUMENT }
}

function receiveDocument(json) {
	// receipt of a document
	return { type: RECEIVE_DOCUMENT, json, receivedAt: Date.now() }
}

export function fetchDocument(documentId, isUpdatePrevDoc = false) {
	// remote request for a single document
	return (dispatch, getState) => {
		const state = getState();
		if (state.doc && state.doc.gridDocumentId !== documentId) {
			dispatch(requestFetchDocument());
		}

		return fetchJson('/gridDocuments/' + documentId)
		.then(async json => {
			await dispatch(receiveDocument(json.result.gridDocument));
			if (isUpdatePrevDoc) {
				dispatch(updatePrevDocument(getState().doc));
			}
		}).catch((error) => {
			dispatch(receiveFetchDocumentError());
			console.log(error);
		});
	}
}

function shouldFetchDocument(documentId, state) {
	if(state.doc !== undefined) {
		return (state.doc.gridDocumentId != documentId)
	}
	return true
}

export function fetchDocumentIfNeeded(documentId) {
	// perform a fetch
	return (dispatch, getState) => {
		if (shouldFetchDocument(documentId, getState())) {
			return dispatch(fetchDocument(documentId))
		}
		else {
			return Promise.resolve()
		}
	}
}

function shouldDeleteDocument(state) {
	return !state.isLoading && window.confirm("Are you sure you want to permanently delete this " + state.doc.typeString() + "?")
}

export function deleteDocument(documentId) {
	return (dispatch, getState) => {
		if (shouldDeleteDocument(getState())) {
			documentId = documentId != null ? documentId : getState().doc.gridDocumentId
			dispatch(requestDeleteDocument(documentId))
			let endpoint = "/gridDocuments/" + documentId
			return fetchJson(endpoint, 'delete')
			.then(json => {
				if(json.error !== undefined && json.error !== true) {
					dispatch(deletedDocument(documentId))
					sessionStorage.setItem('ignoreToShowUnsavedChanges', 'true');
					window.location = "/documents"
				}
			})
		}
		else {
			return Promise.resolve()
		}
	}
}

export async function getUserBrowser (gridDocumentId) {
	let apiRoute = `/userBrowser?gridDocument=${gridDocumentId}`;
	// if (!JSON.parse(sessionStorage.getItem('timeCreatedBrowser'))) {
	// 	apiRoute += '?isDeleted=1'
	// }

	await axios.get(apiRoute, {
        headers: {
        'Cache-Control':  'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        'Pragma': 'no-cache',
            'Expires': '0'
    }
    })
		.then(function (response) {
			if (response.data.userBrowser && ((JSON.parse(sessionStorage.getItem('timeCreatedBrowser'))
				&& JSON.parse(sessionStorage.getItem('timeCreatedBrowser')).gridDocumentId === gridDocumentId
				&& response.data.userBrowser.createdAt !== JSON.parse(sessionStorage.getItem('timeCreatedBrowser')).createdAt)
				|| !JSON.parse(sessionStorage.getItem('timeCreatedBrowser')))) {
				sessionStorage.removeItem('documentEdited');
				document.getElementById("popup-userBrowser").style.display = "block";
				document.getElementById("ip-address").innerHTML = 'IP Address: ' + response.data.userBrowser.ipAddress;
				document.getElementById("date-time-user-browser").innerHTML = 'Date/Time: ' + response.data.userBrowser.createdAt;
				document.getElementById("browser-info").innerHTML = 'Browser & OS: ' + response.data.userBrowser.browser;
				if (response.data.user) {
					document.getElementById("user-browser-info").innerHTML = 'User: ' + response.data.user.accountName;
				}
			}

		});

}

export async function checkHealth() {
	return await axios.get(`/auth/health?timestamp=${Date.now()}`).then();
}

export function detectLastSelectedCell(selectedElementIds) {
	let lastSelectedCellId = 0;
	if (selectedElementIds != null && selectedElementIds.length > 0) {
		let size = selectedElementIds.length;
		let cellId = null;
		for (let i = 0; i < size; i ++) {
            cellId = "" + selectedElementIds[i];
			if (cellId.indexOf("LAST_") > -1) {
                lastSelectedCellId = parseInt(cellId.split("LAST_")[1]);
			}
		}
		if (lastSelectedCellId === 0) {
            lastSelectedCellId = parseInt(selectedElementIds[size - 1]);
		}
	} else {
		for (let i = -20; i <= 40; i ++ ) {
            let cell = document.getElementsByName("date-" + i)[0]
            if (cell) {
                lastSelectedCellId = cell.getAttribute("id").replace("element-","");
                break;
            }
		}
	}

	return lastSelectedCellId;
}
export function excelFeature (selectedElementIds, currentAttributeName, isCol = false, isCtrl = false, isRow = false, isShift = false) {
	// let isSelectedAll = ísSelectAll()
	let selectedBgColor = "#d7f0fb";
    // if (!isSelectedAll) {
	if (!isShift) {
        if (! isCtrl) {
            // reset
            resetSelectedCells(selectedElementIds);
        }
	} else {
		// console.log("yes")
		var selectedElementIdss = [];
		for (var i = 0; i < selectedElementIds.length; i ++) {
            selectedElementIdss[i] = selectedElementIds[i];
		}
        resetSelectedCells(selectedElementIds);
        let cellId = null;
        for (var i = 0; i < selectedElementIdss.length; i ++ ) {
            cellId = "" + selectedElementIdss[i];

            if (cellId.indexOf("LAST_") >= 0) {
                let cell = document.getElementById("element-" + cellId.split("LAST_")[1])
                if (cell && (cell.style.backgroundColor !== "rgb(215, 240, 251)" || cell.style.backgroundColor !== "#d7f0fb") ) {
                    cell.style.backgroundColor = "#d7f0fb";
                    cell.style.opacity = "0.5";
                    cell.style.disabled = "";


                }
                selectedElementIds.push("LAST_" + cell.getAttribute("id").replace("element-",""));
            } else {
                // selectedElementIds.push(selectedElementIdss[i]);
			}
        }

        let count = 0;
        for (let i = -20; i <= 40 ; i ++) {
            let cell = document.getElementsByName("date-" + i)[0]
            if (cell) {
                count ++;
            }
		}
        var lastSelectedCellId = 0;	// TODO
        // console.log("selectedElementIds.length: " + selectedElementIds.length)
        // console.log("count: " + count)
        // console.log(selectedElementIds)
		if (selectedElementIds.length  === count) {
            let tmp = selectedElementIds[selectedElementIds.length - 1].replace("LAST_", "");
            lastSelectedCellId = parseInt(tmp);
            resetSelectedCells(selectedElementIds);
			// console.log(selectedElementIds)
		} else {
            lastSelectedCellId = detectLastSelectedCell(selectedElementIds);	// TOD
		}

		// console.log("lastSelectedCellId: " + lastSelectedCellId)

		// console.log("lastSelectedCellId: " + lastSelectedCellId);
        // if (selectedElementIds.length > 0) {
        //     lastSelectedCellId = selectedElementIds[selectedElementIds.length - 1];
		// }
        var lastSelectedCell = document.getElementById("element-" + lastSelectedCellId);
        var dateNameStarted = lastSelectedCell.getAttribute("datename");
        var weekNumberStarted = parseInt(lastSelectedCell.getAttribute("week"));

        const dateNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

        var dateNameStartIdx = dateNames.indexOf(dateNameStarted);
        var dateNameEndIdx = dateNames.indexOf(currentAttributeName);
        // console.log("dateNameEndIdx: "  + dateNameEndIdx)
        if (dateNameEndIdx === -1) {	// row was selected
			var weekNumberEnd = parseInt(currentAttributeName);

			if (weekNumberStarted > weekNumberEnd) {
				let tmp = weekNumberStarted;
                weekNumberStarted = weekNumberEnd;
                weekNumberEnd = tmp;
			}
            // console.log("weekNumberStarted:" + weekNumberStarted)
			// console.log("weekNumberEnd:" + weekNumberEnd)
			let autoFocusAlready = false;
            for (let i = -20; i <=40 ; i++) {
                let cell = document.getElementsByName("date-" + i)[0]
                if (cell) {
                	let weekNumber = parseInt(cell.getAttribute("week"));
                	if (weekNumberStarted <= weekNumber && weekNumber <= weekNumberEnd) {
                        // autoFocusAlready = autoFocusToTheFirstSelectedCell(autoFocusAlready, cell)
                        cell.style.backgroundColor = "#d7f0fb";
                        cell.style.opacity = "0.5";
                        cell.style.disabled = "";
						// console.log(selectedElementIds)
                        // console.log("id: " + cell.id.split("element-")[1])
                        // if (selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])) < 0 || selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1])) {
                        if (selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) >= 0 || selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])) >= 0) {
                            // if (selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) < 0 && selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) < 0) {

                        } else {
                            selectedElementIds.push(parseInt(cell.getAttribute("id").replace("element-","")));
                        }

					} else {
                		if (cell.style.backgroundColor === "rgb(215, 240, 251)" || cell.style.backgroundColor === "#d7f0fb") {
                            if (selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])) >= 0 || selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) >= 0) {
                                // if (selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) < 0 && selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) < 0) {

                            } else {
                                selectedElementIds.push(parseInt(cell.getAttribute("id").replace("element-","")));
                            }

						}

                        // console.log("weekNumber:" + weekNumber)
					}
                }
            }
            let firstCellId = "" + selectedElementIds[0];
            firstCellId = firstCellId.replace("LAST_","");
            if ( window.tinymce.activeEditor.id === ("element-content-div-html-" + firstCellId)) {
                firstCellId = "" + selectedElementIds[selectedElementIds.length - 1];
                firstCellId = firstCellId.replace("LAST_","");
            }

            let cell = document.getElementById("element-" + firstCellId);

            autoFocusAlready = autoFocusToTheFirstSelectedCell(autoFocusAlready, cell)
			return;


		} else {	// column was selected
            if (dateNameStartIdx > dateNameEndIdx) {
            	var tmp = dateNameStartIdx;
                dateNameStartIdx = dateNameEndIdx;
                dateNameEndIdx = tmp;
			}
			// console.log("dateNameStartIdx: " + dateNameStartIdx)
            // console.log("dateNameEndIdx: " + dateNameEndIdx)
			let autoFocusAlready = false;
            for (let i = -20; i <=40 ; i++) {
                let cell = document.getElementsByName("date-" + i)[0]
                if (cell) {
                	let datename = cell.getAttribute("datename");
                    let datenameIdex = dateNames.indexOf(datename);
                    if (dateNameStartIdx <= datenameIdex && datenameIdex <= dateNameEndIdx) {
                        autoFocusAlready = autoFocusToTheFirstSelectedCell(autoFocusAlready, cell)
                    // if (weekNumberStarted <= weekNumber && weekNumber <= weekNumberEnd) {
                        cell.style.backgroundColor = "#d7f0fb";
                        cell.style.opacity = "0.5";
                        cell.style.disabled = "";
                        // console.log(selectedElementIds)
                        // console.log("id: " + cell.id.split("element-")[1])
                        if (selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) >= 0 || selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])) >= 0) {
                        // if (selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) < 0 && selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) < 0) {

                        } else {
                            selectedElementIds.push(parseInt(cell.getAttribute("id").replace("element-","")));
						}
                        if (i === 14) {
                            // console.log("yes")
                        }
                    } else {
                        if (cell.style.backgroundColor === "rgb(215, 240, 251)" || cell.style.backgroundColor === "#d7f0fb") {
                            if (selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])) >= 0 || selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) >= 0) {
                                // if (selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) < 0 && selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) < 0) {

                            } else {
                                selectedElementIds.push(parseInt(cell.getAttribute("id").replace("element-","")));
                            }

                        }
                        // if (cell.style.backgroundColor !== "rgb(215, 240, 251)" || cell.style.backgroundColor !== "#d7f0fb") {
                        //     selectedElementIds.push(parseInt(cell.getAttribute("id").replace("element-","")));
                        // }
                        // console.log("weekNumber:" + weekNumber)
                    }
                }
            }
            // if (selectedElementIds.length > 0 ) {
            //     let tmp = "" + selectedElementIds[selectedElementIds.length - 1];
            //     console.log("last: " + tmp + " " + window.tinyMCE.activeEditor.id)
			//
            //     let currentEditorFocus = selectedElementIds[0];
            //     if (window.tinyMCE.activeEditor) {
            //         currentEditorFocus = window.tinyMCE.activeEditor.id.split("element-content-div-html-")[1];
            //     }
            //     window.tinyMCE.get("element-content-div-html-" + currentEditorFocus).focus();
            //     if (tmp.indexOf("LAST_") >= 0) {
            //         if (tmp !== currentEditorFocus) {
            //             window.tinyMCE.get("element-content-div-html-" + tmp.replace("LAST_","")).focus();
            //         }
            //     } else {
            //         if (tmp !== currentEditorFocus) {
            //             window.tinyMCE.get("element-content-div-html-" + tmp).focus();
            //         }
            //     }
            // }
		}
        // console.log(dateNameStartIdx + " " + dateNameEndIdx);

        return;
	}

	// } else {
    //     selectedBgColor = "";
    //     console.log("selectedBgColor: " + selectedBgColor)
	// }

	let autoFocusAlready = false;


	let allCellInARowOrColumnSelected = isAllCellInARowOrColumnSelected(selectedElementIds, currentAttributeName, isCol, isCtrl, isRow);

	let isFirstCellOfAColumn = false;
	let firstCellofColumn = null;
	for (let i = 0; i < selectedElementIds.length; i++) {
		let tmp = "" + selectedElementIds[i];
		if (tmp.indexOf("LAST_") < 0 ) {
			tmp = "LAST_" + tmp;
            selectedElementIds[i] = tmp;
		}
	}

	// console.log(selectedElementIds)
    // console.log("after: " + allCellInARowOrColumnSelected)
    for (let i = -20; i <=40 ; i++) {
        let cell = document.getElementsByName("date-" + i)[0]
        if (cell) {
        	if (isCol && isRow) { // select all
				// fix IE
        		// setTimeout(() => {
                //     if (!autoFocusAlready) {
                //         autoFocusAlready = autoFocusToTheFirstSelectedCell(autoFocusAlready, cell)
                //     }
				// }, 10)
				//
                // addSelectedCell(cell, selectedElementIds)

                // fix IE
                    autoFocusAlready = autoFocusToTheFirstSelectedCell(autoFocusAlready, cell)

                addSelectedCell(cell, selectedElementIds, selectedBgColor, allCellInARowOrColumnSelected, true)
                if (firstCellofColumn == null) {
                	if (selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) >= 0) {
                        selectedElementIds.splice( selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]), 1);
                    }
                    if (selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])) >= 0) {
                        selectedElementIds.splice( selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])), 1);
                    }

                    firstCellofColumn = cell;
                }
			} else {
                let value;
                if (isCol) {
                    value = cell.getAttribute("datename");
                } else {
                    value = cell.getAttribute("week");
                }
                if (currentAttributeName === value) {

                	// focus to the first selected cell to enable the editor
                    // autoFocusAlready = autoFocusToTheFirstSelectedCell(autoFocusAlready, cell)
                    isFirstCellOfAColumn = addSelectedCell(cell, selectedElementIds, selectedBgColor, allCellInARowOrColumnSelected, isFirstCellOfAColumn)

                    if (firstCellofColumn == null && isFirstCellOfAColumn == true) {
                        firstCellofColumn = cell;
                    }
					// console.log(cell.id)
                    autoFocusAlready = autoFocusToTheFirstSelectedCell(autoFocusAlready, cell)
                }
			}


        }
    }
	if (firstCellofColumn != null && selectedElementIds.indexOf("LAST_" + firstCellofColumn.getAttribute("id").replace("element-","")) < 0) {
        selectedElementIds.push("LAST_" + firstCellofColumn.getAttribute("id").replace("element-",""));
        // autoFocusAlready = autoFocusToTheFirstSelectedCell(autoFocusAlready, firstCellofColumn)
	}
	// console.log(selectedElementIds)

}

export function isAllCellInARowOrColumnSelected(selectedElementIds, currentAttributeName, isCol , isCtrl , isRow) {
    for (let i = -20; i <=40 ; i++) {
        let cell = document.getElementsByName("date-" + i)[0]
        if (cell) {
            if (isCol && isRow) { // select all
                if (cell.style.backgroundColor !== "rgb(215, 240, 251)") {
                    return false
                }
            } else {
                let value;
                if (isCol) {
                    value = cell.getAttribute("datename");
                } else {
                    value = cell.getAttribute("week");
                }
                if (currentAttributeName === value) {
                    // focus to the first selected cell to enable the editor

                    if (cell.style.backgroundColor !== "rgb(215, 240, 251)") {
						return false
                    }
                }
            }
        }
    }
    return true;
}
export function ísSelectAll() {
    for (let i = -20; i <=40 ; i++) {
        let cell = document.getElementsByName("date-" + i)[0]
        if (cell) {
			if (cell.style.backgroundColor !== "rgb(215, 240, 251)") {	// "#d7f0fb"
				return false;
			}
        }
    }
    return true;
}

export function changeSelectAllStyle(canSwitchStyle) {
	let selectedCell = 0;
	let cellsInCalendar = 0;
    for (let i = -10; i < 40; i ++) {
        let cell = document.getElementsByName("date-" + i);
        if (cell && cell.length > 0) {
        	// make the select all darker
            if (cell[0].style.backgroundColor === '#d7f0fb' || cell[0].style.backgroundColor  === "rgb(215, 240, 251)" ) {
                selectedCell ++;
            }
            cellsInCalendar ++;
        } else {
            // make the select all lighter
            // this action will be handled in click event on each cells / week number / date name

        }
    }
    let isSelectAll = false;
	if (cellsInCalendar === selectedCell) {
        changeSelectAllToDarker();
        isSelectAll = true;
	} else if (canSwitchStyle) {
        changeSelectAllToLighter();
	}

	// TODO: the below is css in IE
    // _border-color: #000000 #000000 #007bff #000000;
    // _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');
	return isSelectAll;
}

export function changeSelectAllToLighter() {
    // make its lighter
    document.getElementById("selectAllCell").style.borderColor = 'transparent transparent rgb(154, 209, 253) transparent';
}

export function changeSelectAllToDarker() {
    // make it's color darker
    document.getElementById("selectAllCell").style.borderColor = "transparent transparent rgb(133, 169, 197) transparent";
}

export function autoFocusToTheFirstSelectedCell (autoFocusAlready, cell) {
    if (autoFocusAlready === false) {
        if (detectIEBrowser2()) {
            let editorId = null;
            if (window.tinymce.activeEditor) {
            	editorId = window.tinymce.activeEditor.id;
            	if ("element-content-div-html-" + cell.getAttribute("id").replace("element-","") === editorId) {
            		return false;
				}
			}
            setTimeout(() => {
                window.tinymce.activeEditor = window.tinyMCE.get("element-content-div-html-" + cell.getAttribute("id").replace("element-",""))
                window.tinymce.activeEditor.focus();
            }, 10)
        } else {
            window.tinymce.activeEditor = window.tinyMCE.get("element-content-div-html-" + cell.getAttribute("id").replace("element-",""))
            window.tinymce.activeEditor.focus();
        }

        // window.tinyMCE.get("element-content-div-html-" + cell.getAttribute("id").replace("element-","")).focus();
        // window.tinymce.activeEditor.execCommand('selectAll');
    }
    return true;
}

export function addSelectedCell (cell, selectedElementIds, bgColor, allCellInARowOrColumnSelected, isFirstCellOfAColumn) {

    //if (selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])) >= 0 && allCellInARowOrColumnSelected) {
    // if ((selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) >= 0 || selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])) >= 0 )&& allCellInARowOrColumnSelected) {
	if ((cell.style.backgroundColor !== "rgb(215, 240, 251)" || cell.style.backgroundColor !== "#d7f0fb") && allCellInARowOrColumnSelected) {
        cell.style.backgroundColor = "";
        cell.style.opacity = "";
        cell.style.disabled = "";

        // selectedElementIds.splice( selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])), 1);
		if (selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) >= 0) {
            selectedElementIds.splice( selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]), 1);
            // console.log("yyyyy: " + cell.id.split("element-")[1] + " " + allCellInARowOrColumnSelected)
		}
        if (selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])) >= 0) {
            selectedElementIds.splice( selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])), 1);
            // console.log("yyyyy: " + cell.id.split("element-")[1] + " " + allCellInARowOrColumnSelected)
        }


	} else {

        cell.style.backgroundColor = "#d7f0fb";
        cell.style.opacity = "0.5";
        cell.style.disabled = "";

        // if (selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])) < 0) {
        // if (selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) < 0 && selectedElementIds.indexOf(parseInt(cell.id.split("element-")[1])) < 0) {
        if (selectedElementIds.indexOf("LAST_" + cell.id.split("element-")[1]) < 0 ) {
            // selectedElementIds.push("LAST_" + cell.getAttribute("id").replace("element-",""));
            // console.log("yes: " + cell.id.split("element-")[1])
			if (isFirstCellOfAColumn === false) {
                // console.log("yes1")
                isFirstCellOfAColumn = true;
			} else {
                // console.log("yes2")
                selectedElementIds.push("LAST_" + cell.getAttribute("id").replace("element-",""));
			}

		}

	}

	return isFirstCellOfAColumn;


}

function getDocumentFormat (doc) {
	let pageOrientation = Constant.ORIENTATION_PORTRAIT;
	let pageFormat = Constant.FORMAT_LETTER;

	switch(doc.paperSizeId) {
		case 1:
			break;
		case 2:
			pageOrientation = Constant.ORIENTATION_LANDSCAPE;
			break;
		case 3:
			pageFormat = Constant.FORMAT_TABLOID;
			break;
		case 4:
			pageFormat =  Constant.FORMAT_TABLOID;
			pageOrientation =  Constant.ORIENTATION_LANDSCAPE;
			break;
		case 5:
			pageFormat =  Constant.FORMAT_LEGAL;
			break;
		case 6:
			pageFormat =  Constant.FORMAT_LEGAL;
			pageOrientation =  Constant.ORIENTATION_LANDSCAPE;
			break;
		default:
			break;
	}
	return {
		pageFormat: pageFormat,
		pageOrientation: pageOrientation
	}
}
// these export functions don't change state within the requesting app instance,
// so they are only network calls unless we need to signal other UI changes upon download / view
export function exportDocumentDownload(templateMode = false, ownerId, token) {
	return (dispatch, getState) => {
		const forDocumentId = getState().doc.gridDocumentId;
		const document =  getState().doc;
		const format = getDocumentFormat(document);
		const documentName = document.name.replace(/[^a-zA-Z0-9-_ ]/g, "");

		if(forDocumentId !== undefined) {
            setTimeout(async () => {
				await createToken();
				const authToken = await getNewTokenFromServer(ownerId);
				if (authToken) {
					token = authToken;
				}

                window.location.href = (Constant.micro_url + '/export/remote/' + forDocumentId + '?download=true&ownerId=' + ownerId + '&authToken=' + token + '&template=' + (templateMode ? "true" : "false")   + '&pageOrientation=' + format.pageOrientation + '&pageFormat=' + format.pageFormat + '&docName=' + documentName)
			}, 10)

			setTimeout(() => {
				$('#loading').hide();
			}, 5000);
			return Promise.resolve(true)
		}
	}
}

export function exportDocumentView(templateMode = false, ownerId, token) {
	return (dispatch, getState) => {
		const forDocumentId = getState().doc.gridDocumentId;
		const format = getDocumentFormat(document);
		const documentName = document.name.replace(/[^a-zA-Z0-9-_ ]/g, "");

		if(forDocumentId !== undefined) {
			setTimeout(async () => {
				await createToken();
				const authToken = await getNewTokenFromServer(ownerId);
				if (authToken) {
					token = authToken;
				}
				window.open(Constant.micro_url + '/export/remote/' + forDocumentId + "?template=" + (templateMode ? "true" : "false") + '&ownerId=' + ownerId + '&authToken=' + token  + '&pageOrientation=' + format.pageOrientation + '&pageFormat=' + format.pageFormat + '&docName=' + documentName, '_blank')
				return Promise.resolve(true)
			}, 10)
		}
	}
}

export function persistPage(page) {
  return (dispatch, getState) => {
    const state = getState();
    if (state.isLossConnect && isEditingCalendar(state)) {
      dispatch(storePageInStorage(page));
    } else {
      dispatch(storePageInDatabase(page));
    }
  }
}

export function storePageInStorage(page) {
  return dispatch => {
    OfflineSaveService.getInstance().persistPage(page);
    dispatch(receivePage(page));
  }
}

export function storePageInDatabase(page) {
	return (dispatch, getState) => {
		dispatch(uiSaving())

		const state = getState();
		if (isEditingCalendar(state)) {
			OfflineSaveService.getInstance().removeGridDocumentPage(page.gridDocumentPageId);
		}

		let payload = JSON.stringify(Object.assign({}, page))
		let persistPath = '/gridDocuments/' + page.gridDocumentId + '/gridDocumentPages/' + page.page
		return fetchJson(persistPath,
			'post',
			payload
		)
			.then(json => {
				dispatch(receivePage(json.result.gridDocumentPage));
				// ThumbnailGenerationService.getInstance().add(getState().doc.gridDocumentId, getState().currentUser.userId);
			})
	}
}

export function createPage(page) {
	return dispatch => {
		dispatch(uiSaving())

		let payload = JSON.stringify(Object.assign({}, page));
		let persistPath = '/gridDocuments/' + page.gridDocumentId + '/gridDocumentPages/' + page.page;

		return fetchJson(persistPath, 'put', payload).then((json) => {
			dispatch(receivePage(json.result.gridDocumentPage))
		});
	}
}

function receivePage(page) {
	// sucessful fetch, with a result of some kind
	return { type: RECEIVE_PAGE, page: page, receivedAt: Date.now() }
}

export function createElement(element) {
	return dispatch => {
		dispatch(uiSaving())
		let payload = JSON.stringify(Object.assign({}, element))
		let createPath = "/gridDocuments/" + element.gridDocumentId + "/gridElements"
		return fetchJson(createPath, 'put', payload)
		.then(json => {
			dispatch(receiveElement(json.result.gridElement))
		})
	}
}

export function removeHandCursorInCells() {
    for (let i = -10; i <= 40; i++) {
        if (document.getElementsByName("date-" + i).length > 0) {
            document.getElementsByName("date-" + i)[0].style.cursor = 'text';
        }
    }
}
export function resetSelectedCells(selectedElementIds) {
    // un-select all the selected cells
	let tmp;
    for (let i = 0 ; i < selectedElementIds.length; i++) {
    	tmp = "" + selectedElementIds[i];
    	tmp = tmp.replace("LAST_", "");
        if (document.getElementById("element-" + tmp)) {
            document.getElementById("element-" + tmp).style.backgroundColor = "";
            document.getElementById("element-" + tmp).style.opacity = "";
            document.getElementById("element-" + tmp).style.disabled = "";
        }
    }
    selectedElementIds.length = 0;
}

export function isCtrlOrCommand(event) {
    let isMac = navigator.platform.indexOf("Mac") >= 0 ? true: false;
    let isCtrl = false;
    if (isMac) {
        if (event.metaKey) {
            isCtrl = true;
        }
    } else {
        isCtrl = event.ctrlKey;
    }

    return isCtrl;
}
export function disableMultiSelectMode(selectedElementIds, multipleSelectMode, pageNumber = 1) {

    resetSelectedCells(selectedElementIds);
    removeHandCursorInCells();
    changeSelectAllToLighter();

    // clear the multi-select cache
    multipleSelectMode.length = 0;

    // switch off the "Multi-select mode" icon
    // document.getElementById("multi-select").style = "";
    document.getElementById("multi-select").style.backgroundColor = "";
    document.getElementById("multi-select").style.borderColor = "";

    document.getElementById("multi-select").setAttribute("data-multi-select", "true");

    // hide the excel bar
    document.getElementById("selectAllCellDiv").style.display = "none"

    // enable header/footer
    disableHeaderAndFooterCell(false, pageNumber);


    setTimeout(() => {
        lostFocusCalendar();
    }, 100);
}

export function changeHandStyleToCells() {
    for (let i = -10; i <=40 ; i++) {
        let cell = document.getElementsByName("date-" + i)[0]
        if (cell) {
            cell.style.cursor = "pointer";
        }
    }
}

export function lostFocusCalendar() {
    document.getElementById("gridDocumentPageContainer").click();
}

export function autoFocusFirstCellInCalendar() {
    for (let i = -10; i < 40; i++) {
        let firstCell = document.getElementsByName("date-" + i);
        if (firstCell && firstCell.length > 0) {
            let id = firstCell[0].getAttribute("id").replace("element-", "");
            window.tinyMCE.get("element-content-div-html-" + id).focus();
            return;
        }
    }
}
export function disableHeaderAndFooterCell(isDisabled, pageNumber = 1){
    let nodes = document.getElementsByClassName('gridDocumentPageContent')[0].childNodes;
    let header = null;
    if (pageNumber == 1) {
        header = nodes[nodes.length - 2];
    // } else if (pageNumber == 5) {
    //     header = nodes[2];
    } else {

	}

    let footer = nodes[1];
    let disableBgColor = '';
    if (isDisabled) {
        disableBgColor = '#ddd';
        let footerName = footer.childNodes[1].getAttribute("name");
		if (isNaN(parseInt(footerName.split("-")[1])) ) {
			footer.childNodes[1].style.pointerEvents = 'none'
			footer.childNodes[1].style.backgroundColor = disableBgColor;
		}

        if (header && header.childNodes[1].offsetHeight >= 40) {
            header.childNodes[1].style.pointerEvents = 'none'
            header.childNodes[1].style.backgroundColor = disableBgColor;
        }
    } else {
        let footerName = footer.childNodes[1].getAttribute("name");
        if (isNaN(parseInt(footerName.split("-")[1]))) {
            footer.childNodes[1].style.pointerEvents = 'initial'
            footer.childNodes[1].style.backgroundColor = disableBgColor;
        }

        if (header && header.childNodes[1].offsetHeight >= 40) {
            header.childNodes[1].style.pointerEvents = 'initial'
            header.childNodes[1].style.backgroundColor = disableBgColor;
        }
    }

    if (!header) {
        let headers = document.getElementsByName('date-');
        for (let i = 1; i < headers.length; i ++) {
        	if (isDisabled) {
                headers[i].style.pointerEvents = 'none'
			} else {
                headers[i].style.pointerEvents = 'initial'
			}
            headers[i].style.backgroundColor = disableBgColor;
        }
	}
}

export function  excelAction(elementId) {

}

export function persistElement(element, willClose = false) {
  return (dispatch, getState) => {
    const state = getState();
    if (state.isLossConnect && isEditingCalendar(state)) {
      dispatch(storeElementInStorage(element, willClose));
    } else {
      dispatch(storeElementInDatabase(element, willClose));
    }
  }
}

export function storeElementInStorage(element, willClose = false) {
  return dispatch => {
    OfflineSaveService.getInstance().persistElement(element);
    dispatch(receiveElement(element, willClose));
  }
}

export function storeElementInDatabase(element, willClose = false) {
	return (dispatch, getState) => {
		const state = getState();
		if (state.doc.gridDocumentId === element.gridDocumentId) {
			dispatch(uiSaving())

			if (isEditingCalendar(state)) {
				OfflineSaveService.getInstance().removeGridElement(element.gridElementId);
			}

			// let payload = JSON.stringify(Object.assign({}, element))
			let persistPath = '/gridDocuments/' + element.gridDocumentId + '/gridElements/' + element.gridElementId
			let expiredText = "Session expired. Please return to ActivityConnection website.";

			if(!willClose) {
				dispatch(receiveElement(element, willClose))
			}

			axios.post(persistPath, Object.assign({}, element))
			.then(function (response) {
				if(willClose) {
					dispatch(receiveElement(response.data.result.gridElement, willClose))
				}

				if (response.data === expiredText) {
					document.getElementById("popup-missing-cookie").style.display = "block";
				} else {
					// ThumbnailGenerationService.getInstance().add(getState().doc.gridDocumentId, getState().currentUser.userId);
	      }
			})
			.catch(function (error) {
				console.log(error);
			});
		}
	}
}

export function deleteElement(element) {
	const elementIdToRemove = element.gridElementId
	return dispatch => {
		dispatch(uiSaving())
		let payload = JSON.stringify({ gridElementId: elementIdToRemove })
		let persistPath = '/gridDocuments/' + element.gridDocumentId + '/gridElements/' + element.gridElementId
		return fetchJson(persistPath,
			'delete',
			payload
		)
		.then(json => {
			dispatch(removeElement(elementIdToRemove))
		})
	}
}

function receiveElement(element, willClose = false) {
	// sucessful fetch, with a result of some kind
	return { type: RECEIVE_ELEMENT, element: element, receivedAt: Date.now(), willClose }
}

function removeElement(elementId) {
	return { type: REMOVE_ELEMENT, elementId: elementId }
}

function fetchElements(documentId) {
	// remote request for elements of a document
	/* For now, entire array is handled in receiveDocument, this handles single updates
	return dispatch => {
		// dispatch(uiFetching())
		return fetch('/gridDocument/' + documentId + '/elements')
		.then(response => response.json())
		.then(json => dispatch(receiveElement(json)))
	}
	*/
}

function shouldFetchElements(state) {
	// TODO: Shield on outstanding requests, e.g. !state.isLoading
	return true
}

export function fetchElementsIfNeeded(documentId) {
	// perform a remote request if we pass business logic
	return (dispatch, getState) => {
		if (shouldFetchElements(getState())) {
			return dispatch(fetchElements(documentId))
		}
		else {
			return Promise.resolve()
		}
	}
}

export function reloadImageLibrary() {
  return dispatch => {
    dispatch(imageLibraryReload());
  }
}

export function storeImageInStorage(formData) {
  return async dispatch => {
    const image = await OfflineSaveService.getInstance().persistImage(formData);
    if (image) {
      dispatch(imageLibraryUploadComplete({ result: { image }, error: false, status: 200 }));
    }
  }
}

export function persistImage(formData) {
	return async dispatch => {
		dispatch(uiSaving());
		let persistPath = '/images';
		return await fetchJson(persistPath,
			'post',
			formData
		)
		.then(json => {
			dispatch(imageLibraryUploadComplete(json))
		})
	}
}

export function persistBackgroundImage(formData) {
	return dispatch => {
		dispatch(uiSaving())
		let persistPath = '/images'
		return fetchJson(persistPath,
			'post',
			formData
		)
		.then(json => {
			dispatch(documentSetBackgrounds(json.result.image.imageId))
		})
	}
}

function receiveImagesIndex(imagesByCategory) {
	// sucessful fetch, with a result of some kind
	return { type: RECEIVE_IMAGES_INDEX, imagesByCategory: imagesByCategory, receivedAt: Date.now() }
}

function fetchImagesIndex(month, year, isTemplate) {
	// remote request for images belonging in the selected date
	// (visible to the requesting user, implicitly)
	return dispatch => {
		// dispatch(uiFetching())
		return fetchJson('/images/browse/' + year + '/' + month + '/' + isTemplate)
		.then(json => {
			if (json && json.result) {
				dispatch(receiveImagesIndex(json.result.imagesByCategory))
			}
		})
	}
}

function shouldFetchImagesIndex(state) {
	const hasLoadedImageLibrary = state.imageLibrary.isShown
	const lastRequest = state.imageLibrary.lastImagesRequest
	const isLoading = (lastRequest.isLoading === true)
	const documentDefined = (state.doc.month !== undefined && state.doc.year !== undefined)
	const hadLastRequest = (lastRequest.month !== undefined && lastRequest.year !== undefined)
	const sameMonth = (lastRequest.month === state.doc.month)
	const sameYear = (lastRequest.year === state.doc.year)

	// NEVER fire this request unless the image library is loaded
	return (hasLoadedImageLibrary && documentDefined && !isLoading && !hadLastRequest && (!sameMonth || !sameYear))
}

export function fetchImagesIndexIfNeeded(month, year, isTemplate) {
	// perform a remote request if we pass business logic
	return (dispatch, getState) => {
		if (shouldFetchImagesIndex(getState())) {
			dispatch(uiImageLibraryLoading(true))
			return dispatch(fetchImagesIndex(month, year, isTemplate)).then(() => {
				dispatch(uiImageLibraryLoading(false))
			})
		}
		else {
			return Promise.resolve()
		}
	}
}

export function requestOrderPrints(documentId, currentUser, PSP_URL, pageFormat, pageOrientation) {
	return dispatch => {
		// Get user From PSP
		const userOut = UserOutPSP.buildFromJson(currentUser)
		return fetchJson('/pps/requestOrderPrints/' + documentId,'post')
		.then(json => {
			if(json.success === true && json.documentId && json.productId  && json.token) {
				return openOrderPSP(json.documentId, json.productId, PSP_URL, json.token, json.authToken,json.ownerId, json.fileName,  pageFormat, pageOrientation)
			}
			alert("Sorry we don't support printing for this document template at this time.")
		})
	}
}

function openOrderPSP(documentId, productId, PSP_URL, token, authToken, ownerId,fileName,  pageFormat, pageOrientation) {
	let endpoint = PSP_URL + '/#/print-order/new';
	let fileDocumentName = fileName.replace(/[^a-zA-Z0-9-_ ]/g, "");

	let parameters = "sharetoken=" + token
	parameters += "&authToken=" + authToken
	parameters += "&ownerId=" + ownerId
	parameters += "&docid=" + documentId
	parameters += "&filename=" + fileDocumentName
	parameters += "&filetype=pdf"
	parameters += "&productid=" + productId
	parameters += "&pageFormat=" + pageFormat
	parameters += "&pageOrientation=" + pageOrientation
    parameters += "&timestamp" + (new Date()).getTime();

	if (parameters) {
		endpoint = endpoint + "?" + parameters
	}
	window.open(endpoint,'_blank').focus()
}

function receivePaperSizesIndex(paperSizes) {
	// successful fetch, with a result of some kind
	return { type: RECEIVE_PAPER_SIZES_INDEX, paperSizes: paperSizes, receivedAt: Date.now() }
}

function fetchPaperSizesIndex() {
	// remote request for images belonging in the selected date
	// (visible to the requesting user, implicitly)
	return dispatch => {
		// dispatch(uiFetching())
		return fetchJson('/paperSizes')
			.then(json => {
				dispatch(receivePaperSizesIndex(json.result.paperSizes))
			})
	}
}

function shouldFetchPaperSizesIndex(state) {
	// TODO: Shield on outstanding requests, e.g. !state.isLoading
	return state.paperSizes == null || state.paperSizes.length == 0
}

function fetchDocumentTemplates(typeId = null, year = null, month = null, sizeId = null, layoutId = null, categoryName = null, isBranded = null) {
	return dispatch => {
		dispatch(requestDocumentTemplates())
		let endpoint = "/gridDocuments/template"
		let parameters = ""

		if (typeId !=null) {
			parameters = parameters + (parameters ? "&" : "") + "typeId=" + typeId
		}
		if (year) {
			parameters = parameters + (parameters ? "&" : "") + "year=" + year
		}
		if (month) {
			parameters = parameters + (parameters ? "&" : "") + "month=" + month
		}
		if(sizeId != null && sizeId != ''){
			parameters = parameters + (parameters ? "&" : "") + "paperSizeId=" + sizeId
		}
		if(layoutId != null){
			parameters = parameters + (parameters ? "&" : "") + "layoutId=" + layoutId
		}
        if(categoryName != null){
            parameters = parameters + (parameters ? "&" : "") + "categoryName=" + categoryName
        }

		isBranded = isBranded ? isBranded : ''
		parameters = parameters + (parameters ? "&isBranded=" + isBranded : "isBranded=" + isBranded);

		if (parameters) {
			endpoint = endpoint + "?" + parameters
		}

		return fetchJson(endpoint)
		.then(json => {
			dispatch(receiveDocumentTemplates(json.result.gridDocuments))
		})
	}
}

function fetchPSPProducts() {
    return fetchJson('/pps/products','get')
        .then(json => {
            let initialPlanets = json.map((product) => {
                return product
            });
            return initialPlanets;
        })
}


function shouldFetchDocumentTemplates(state) {
	return !state.isLoadingDocumentTemplates
}

export function fetchDocumentTemplatesIfNeeded(typeId = null , year = null, month = null, sizeId = null, layoutId = null, categoryName = null, isBranded = null) {
    return (dispatch, getState) => {
        if (shouldFetchDocumentTemplates(getState())) {
            // Remove Selected template when load document template
            dispatch(setSelectedDocumentTemplate(null))
            return dispatch(fetchDocumentTemplates(typeId, year , month, sizeId, layoutId, categoryName, isBranded))
        }
        else {
            return Promise.resolve()
        }
    }
}

export function fetchPSPProductIfNeeded() {
    return fetchPSPProducts()
}

export function fetchPaperSizesIfNeeded() {
	// perform a remote request if we pass business logic
	return (dispatch, getState) => {
		if (shouldFetchPaperSizesIndex(getState())) {
			//dispatch(uiImageLibraryLoading(true))
			return dispatch(fetchPaperSizesIndex()).then(() => {
				//dispatch(uiImageLibraryLoading(false))
			})
		}
		else {
			return Promise.resolve()
		}
	}
}

export function setRoute(newValue) {
	if(document.router !== undefined) {
		document.router.setRoute(newValue)
	}
}

export function setSelectedDocumentTemplate(document) {
	return { type: SET_SELECTED_DOCUMENT_TEMPLATE, document }
}

export function setCreateTemplate(createTemplate = false) {
	return { type: SET_CREATE_TEMPLATING, createTemplate }
}

export function setYear(value) {
	return { type: FILTER_TEMPLATE_YEAR, value }
}

export function setMonth(value) {
	return { type: FILTER_TEMPLATE_MONTH, value }
}

export function setsizeId(value) {
	return { type: FILTER_TEMPLATE_SIZE, value }
}

export function setLayoutId(value) {
	return { type: FILTER_TEMPLATE_LAYOUT, value }
}

export function setMultipleSelectMode(value) {
    return { type: MULTI_SELECT_MODE, value }
}

export function refreshDocumentTemplates(typeId) {
	return (dispatch, getState) => {
		const filterTemplate = getState().filterTemplate;
		return dispatch(fetchDocumentTemplatesIfNeeded(typeId, filterTemplate.year, filterTemplate.month, filterTemplate.sizeId, filterTemplate.layoutId, filterTemplate.categoryName))
	}
}

export function isEditingCalendar(state) {
	return (state.scenario === "calendar" && state.doc && state.doc.isTemplate !== 1);
}

export function isDataChanges(state) {
	if (state.doc && state.doc.parentGridDocumentId) return false;

	const prevDoc = (state.prevDoc && !$.isEmptyObject(state.prevDoc)) ? getCompareData(state.prevDoc) : undefined;
	const doc = (state.doc && !$.isEmptyObject(state.doc)) ? getCompareData(state.doc) : undefined;
	return (prevDoc !== doc);
}

function getCompareData(doc) {
  const gridElements = doc.GridElement.map((item) => {
    return {
      name: item.name,
      page: item.page,
      text: item.text,
      top: item.top,
      left: item.left,
      width: item.width,
      height: item.height,
      shouldShrinkToFit: item.shouldShrinkToFit,
      backgroundColor: item.backgroundColor,
      backgroundImageId: item.backgroundImageId,
      borderColor: item.borderColor,
      borderWidth: item.borderWidth,
      borderStyle: item.borderStyle,
      opacity: item.opacity,
      zIndex: item.zIndex,
      backgroundPosition: item.backgroundPosition,
      backgroundSize: item.backgroundSize,
      backgroundSketch: item.backgroundSketch,
      footerText: item.footerText,
      cellAlign: item.cellAlign,
      rightText: item.rightText,
      leftText: item.leftText
    }
  });

  const gridDocumentPages = doc.GridDocumentPage.map((item) => {
    return {
      backgroundImageId: item.backgroundImageId,
      backgroundImageTransparency: item.backgroundImageTransparency
    }
  });

  return JSON.stringify({ gridElements, gridDocumentPages });
}

function shouldFetchTooltips(state) {
  return !state.isLoadingTooltips;
}

export function fetchTooltipsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchTooltips(getState())) {
      return dispatch(fetchTooltips());
    } else {
      return Promise.resolve();
    }
  }
}

function fetchTooltips() {
  return dispatch => {
    dispatch(requestTooltips());
    const endpoint = `/tooltips/list`;
    return fetchJson(endpoint)
      .then(json => {
        if (json && json.result) {
          dispatch(receiveTooltips(json.result));
        }
      }).catch(function (error) {
        dispatch(receiveTooltipsError());
        console.log(error);
      });
  }
}

function showRevisionHistory(value = false) {
	return { type: SHOW_REVISION_HISTORY, value }
}

function shouldFetchRevisions(state) {
  return !state.isLoadingRevisions;
}

export function fetchRevisionsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchRevisions(getState())) {
      const doc = getState().doc;
      const parentGridDocumentId = doc.parentGridDocumentId ? doc.parentGridDocumentId : doc.gridDocumentId;
      return dispatch(fetchRevisions(parentGridDocumentId));
    } else {
      return Promise.resolve();
    }
  }
}

function fetchRevisions(gridDocumentId) {
  return dispatch => {
    dispatch(requestRevisions());
    const endpoint = `/gridDocuments/${gridDocumentId}/revisions`;
    return fetchJson(endpoint)
      .then(json => {
        if (json && json.result) {
          dispatch(receiveRevisions(json.result.revisions));
          dispatch(showRevisionHistory(json.result.revisions.length > 0));
        }
      }).catch(function (error) {
        dispatch(receiveRevisionsError());
        console.log(error);
      });
  }
}

export function createRevision(gridDocumentId, versionName, isBackToList) {
  return (dispatch, getState) => {
    const endpoint = `/gridDocuments/${gridDocumentId}/createRevision`;
    axios.post(endpoint, { versionName })
      .then(function (response) {
        if (!isBackToList) {
          dispatch(updatePrevDocument(getState().doc));
          dispatch(fetchRevisionsIfNeeded());
        }
      }).catch(function (error) {
        console.log(error);
      });
  }
}

export async function showMasterRevision(gridDocumentId) {
  await updateIsNotEditing();
  sessionStorage.setItem('ignoreToShowUnsavedChanges', 'true');
  window.location.href = `/editor/${gridDocumentId}`;
}

export async function updateIsNotEditing() {
  if (sessionStorage.getItem('documentEdited')) {
    const documentEdited = JSON.parse(sessionStorage.getItem('documentEdited'));
    if (documentEdited.gridDocumentId) {
      await fetch(`/gridDocuments/updateEditing/${documentEdited.gridDocumentId}?isEditing=0`, { method:'get', keepalive: true })
        .then(function (response) {})
        .catch(function (error) {
          console.log(error);
        });
    }
    sessionStorage.removeItem('documentEdited');
  }
}

export function restoreRevision(revisionGridDocumentId, gridDocumentId) {
  return (dispatch, getState) => {
    const endpoint = `/gridDocuments/${revisionGridDocumentId}/restoreRevision`;
    return axios.post(endpoint, {})
      .then(json => {
        dispatch(fetchRevisionsIfNeeded());
        dispatch(fetchDocument(gridDocumentId, true));
        ThumbnailGenerationService.getInstance().add(gridDocumentId, getState().currentUser.userId);
      }).catch(function (error) {
        console.log(error);
      });
  }
}

export function save(gridDocument, name) {
  return (dispatch, getState) => {
    $('#loading').show();

    const docSaving = Object.assign(gridDocument, { name });
    const endpoint = `/gridDocuments/${gridDocument.gridDocumentId}/save`;
    return fetchJson(endpoint, 'put', docSaving.serialize())
      .then(async json => {
        if (json && json.result) {
          if (json.result.invalid) {
            alert(json.result.invalid);
          } else {
            let doc = json.result.gridDocument;
            doc.isNotComputeGrid = true;
            await dispatch(updateDocument(doc));

            const state = getState();
            dispatch(updatePrevDocument(state.doc));
            dispatch(fetchRevisionsIfNeeded());

            OfflineSaveService.getInstance().removeGridDocument(doc.gridDocumentId);
            OfflineSaveService.getInstance().removeGridElementsAndPages(doc.gridDocumentId);
            ThumbnailGenerationService.getInstance().add(doc.gridDocumentId, state.currentUser.userId);
          }
        } else {
          const gridDocumentId = gridDocument.gridDocumentId;
          dispatch(fetchRevisionsIfNeeded());
          dispatch(fetchDocument(gridDocumentId, true));
          ThumbnailGenerationService.getInstance().add(gridDocumentId, getState().currentUser.userId);
        }
        $('#loading').hide();
      }).catch((err) => {
        $('#loading').hide();
        alert("Save failed, please try again");
        console.log("Error:", err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/data/EditorActions.js